import { AvailableLocale } from '@omnea-digital/toolbox'
import { DateFormatKey } from 'utils/date/dateFormat'
import { components } from '@omnea-app/users/usersHttpClient/usersGeneratedTypes'
import { getBrowserLocale, isBrowserDateFormatAmerican } from './getBrowserLocale'

export type LocaleSource = 'userPreference' | 'browserLocale' | 'organisationDefault' | 'systemDefault'

interface LocaleResult {
  locale: AvailableLocale
  localeSource: LocaleSource
}

export const determineLocale = (userData?: components['schemas']['UserInfo'] | null): LocaleResult => {
  // 1. User preference
  if (userData?.languagePreference) {
    return {
      locale: userData.languagePreference,
      localeSource: 'userPreference',
    }
  }

  const isBrowser = typeof window !== 'undefined'
  if (isBrowser) {
    // 2. Browser locale
    const browserLocale = getBrowserLocale()
    if (browserLocale) {
      return { locale: browserLocale, localeSource: 'browserLocale' }
    }
  }

  // 3. Organisation default
  if (userData?.orgLanguagePreference) {
    return {
      locale: userData.orgLanguagePreference,
      localeSource: 'organisationDefault',
    }
  }

  // 4. Default to British English
  return { locale: 'en-GB', localeSource: 'systemDefault' }
}

interface DateFormatResult {
  datePickerFormat: DateFormatKey
  datePickerFormatSource: LocaleSource
}

export const determineDateFormat = (userData?: components['schemas']['UserInfo'] | null): DateFormatResult => {
  // 1. User preference
  if (userData?.dateFormatPreference) {
    return {
      datePickerFormat: userData.dateFormatPreference,
      datePickerFormatSource: 'userPreference',
    }
  }

  // 2. Browser locale
  if (isBrowserDateFormatAmerican()) {
    return {
      datePickerFormat: 'MDY',
      datePickerFormatSource: 'browserLocale',
    }
  }

  // 3. Organisation default
  if (userData?.orgDateFormatPreference) {
    return {
      datePickerFormat: userData.orgDateFormatPreference,
      datePickerFormatSource: 'organisationDefault',
    }
  }

  // 4. Default to British English
  return { datePickerFormat: 'DMY', datePickerFormatSource: 'systemDefault' }
}
